export default __webpack_public_path__ + "static/media/girl-climber.ff65ec3f.jpeg";